// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"ZY-z","sponsoredTooltipWrapper":"_Y-z","sponsoredTooltip":"aZ-z","newCard":"bZ-z"};